import { defaultDataIdFromObject, InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloClient } from 'apollo-client'
import localforage from 'localforage'
import { CacheShape } from '../../generated/graphql'
import ApolloPersistor from './helpers/ApolloPersistor'
import { unifiedLink as unifiedApolloLink } from '@edge/spark/io-apollo'

export const cache = new InMemoryCache({
    // https://www.apollographql.com/docs/react/v2/caching/cache-configuration#custom-identifiers
    dataIdFromObject: (object) => {
        switch (object.__typename) {
            case 'ServiceOrder':
                if ('stockNumber' in object) {
                    return (object as { stockNumber: string }).stockNumber
                }
                break
            default:
                return defaultDataIdFromObject(object)
        }
    },
})

//  singleton
export const persistor = new ApolloPersistor({
    cache,
    // https://github.com/apollographql/apollo-cache-persist/issues/55
    storage: localforage as any,
    maxSize: false,
})

export const unifiedClient = new ApolloClient<CacheShape>({
    link: unifiedApolloLink,
    cache,
})
